import { Box, Typography } from "@mui/material";
import { CategoriesPanelContainer, CategoryAvatar } from "./CarePortal.style";
import { GeneralCareItem, IPetItemResponse } from "../../../services/Standard-of-care/standard-of-care.interface";
import { HealthRecordsIcon, PawIcon, PrescriptionIcon, WellnessPlanIcon } from "../../../components/Icons";

import HealthRecordsContainer from "../HealthRecordsContainer/HealthRecordsContainer";
import { Loading } from "../../../components";
import PrescriptionsContainer from "../PrescriptionsContainer/PrescriptionsContainer";
import React from "react";
import StandardOfCareContainer from "../StandardOfCareContainer/StandardOfCareContainer";
import WellnessPlanContainer from "../WellnessPlanContainer/WellnessPlanContainer";

type Props = {
  careData: GeneralCareItem
  petData: IPetItemResponse;
  selectedCategory: string;
  onSelectCategory: (type: string) => void;
  petList : IPetItemResponse[];
  handlePetChange: (petId: string, category?: string) => void;
  hospitalDetailsContentful?: any;
}

export const CATEGORIES_LIST = [
  { type: "Care", icon: <PawIcon/> },
  { type: "TotalCare_Plan", icon: <WellnessPlanIcon/>, activeIcon: <WellnessPlanIcon isActive={true}/> },
  { type: "Prescriptions", icon: <PrescriptionIcon/> },
  { type: "Health_Records", icon: <HealthRecordsIcon/> },
];
const CategoriesPanel = (props: Props) => {
  const { careData, petData, onSelectCategory, selectedCategory, petList,
    handlePetChange, hospitalDetailsContentful } = props;

  const handleSelectCategory = (type: string)=>{
    onSelectCategory(type);
  };

  const SOC_DATA = {
    "Diagnostic": careData?.diagnostic,
    "Vaccination": careData?.vaccination,
    "Preventative": careData?.preventativeMedication,
    "Dental": careData?.dental,
  };

  function getCategoryChildren(category: string) {
    switch (category) {
    case "Care":
      return <StandardOfCareContainer socData={SOC_DATA} petData={petData}/>;
    case "TotalCare_Plan":
      return <WellnessPlanContainer petData={petData} petList={petList} handlePetChange={handlePetChange}
        hospitalDetailsContentful={hospitalDetailsContentful} handleSelectCategory={handleSelectCategory}/>;
    case "Prescriptions":
      return <PrescriptionsContainer prescription={careData.prescription} petData={petData}/>;
    case "Health_Records":
      return <HealthRecordsContainer careData={careData} petData={petData}/>;
    default:
      return <Typography variant="h4" fontWeight={600}>Standard of Care</Typography>;
    }
  }


  return (
    <CategoriesPanelContainer
      className="flex flex-col gap-3 sm:max-w-full max-w-[24rem] md:max-w-[40rem] lg:max-w-[34rem] 2xl:max-w-[42rem]">
      <div className="flex flex-col py-4 items-start self-stretch border-b border-gray-3">
        <div className="flex justify-around items-start self-stretch">
          {CATEGORIES_LIST.map((category) => (
            <div className="flex flex-col gap-1 items-center" key={category.type}
              onClick={()=>handleSelectCategory(category.type)}>
              <CategoryAvatar
                isActive={selectedCategory === category.type}
                isWellness={category.type==="TotalCare_Plan"}>
                <div>
                  {category.type==="TotalCare_Plan" &&
                  selectedCategory === category.type ? category.activeIcon: category.icon}
                </div>
              </CategoryAvatar>
              <Typography variant="subtitle1" className="!text-[11px] !sm:text-xs">
                {category.type.replace("_", " ")}</Typography>
            </div>
          ))}
        </div>
      </div>
      <div className="w-full h-full pb-10">
        {!(hospitalDetailsContentful && (Object?.keys(hospitalDetailsContentful).length)) ?
          <Box className="h-3/4 w-full flex justify-center items-center">
            <Loading />
          </Box>:
          getCategoryChildren(selectedCategory)}
      </div>
    </CategoriesPanelContainer>
  );
};

export default CategoriesPanel;
